// trigger mobile menu
window.addEventListener('load', () => {
    const mobile_menu_triggers = document.querySelectorAll<HTMLElement>("[data-mobile-menu-trigger]");

    let is_open = false;
    const body_class = "mobile-menu-open";

    function toggleMobileMenu() {
        is_open = !is_open;
        if (is_open) {
            document.body.classList.add(body_class);
        } else {
            document.body.classList.remove(body_class);
        }
    }

    mobile_menu_triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            toggleMobileMenu();
        });
    });
});


// extending sub menus
window.addEventListener('load', () => {
    // const
    const sub_menu_items = document.querySelectorAll<HTMLElement>(".MobileMenuComponent ul.mobile-menu > li.menu-item-has-children");
    sub_menu_items.forEach(item => {
        const link = item.querySelector<HTMLElement>("a");
        if (!link) return;

        const expand_btn = document.createElement("button");
        expand_btn.innerHTML = '<i class="fa-regular fa-chevron-down"></i>';
        expand_btn.classList.add("mobile-menu-expand-btn");
        expand_btn.setAttribute("aria-label", "Uitklappen submenu");


        // if the link href is just a #, we also want to toggle on link click
        if (link.getAttribute('href') === '#') {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                item.classList.toggle("expanded");
            });
        } else {
            expand_btn.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle("expanded");
            });
        }

        link.appendChild(expand_btn);

        if (item.classList.contains("current-menu-ancestor")) {
            item.classList.add("expanded");
        }
    });
});
